// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Restaurant from '../_raw/service/icon_restaurant.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Restaurant);
